import { Suspense } from 'react';
import { Pages } from 'assets/js/Pages';
import { PageLoading } from 'assets/js/components/PageLoading';
import 'boot/boot';
import { DevTools } from 'components/devtools/DevTools';
import { GlobalPendingProgress } from 'components/global-pending-progress/GlobalPendingProgress';
import { Router } from 'components/router/Router';
import { history } from 'components/router/history';
import { IS_PRODUCTION } from 'constants/runtime';
import { useAxiosInterceptors } from 'customHooks/useAxiosInterceptors';
import { useCapterra } from 'customHooks/useCapterra';
import { useConfigureHttpClient } from 'customHooks/useConfigureHttpClient';
import { useInitCurrentAccount } from 'customHooks/useInitCurrentAccount';
import { useIntercom } from 'customHooks/useIntercom';
import { useRegisterStaticFilters } from 'customHooks/useRegisterStaticFilters';
import { useRemoteStaticAssets } from 'customHooks/useRemoteStaticAssets';
import { useSift } from 'customHooks/useSift';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond/dist/filepond.min.css';
import { LaunchDarklyProvider } from 'providers/LaunchDarklyProvider';
import { PostHogProvider } from 'providers/PostHogProvider';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const App = () => {
    useConfigureHttpClient();
    useAxiosInterceptors();
    useCapterra();
    useIntercom();
    useSift();
    useInitCurrentAccount();
    useRemoteStaticAssets();
    useRegisterStaticFilters();

    return (
        <LaunchDarklyProvider>
            <PostHogProvider>
                <Pages />
                <GlobalPendingProgress />
                {!IS_PRODUCTION && <DevTools />}
            </PostHogProvider>
        </LaunchDarklyProvider>
    );
};

const WrappedApp = () => {
    return (
        <Suspense fallback={<PageLoading />}>
            <Router history={history}>
                <App />
            </Router>
        </Suspense>
    );
};

export default WrappedApp;
